// extracted by mini-css-extract-plugin
module.exports = {"bold":"styles_bold__45_EC","helperText":"styles_helperText__x8Rzy","footer":"styles_footer__3p0cF","button":"styles_button__1CpTN"};